import React from "react";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";
import { useXp } from "../../lib/gamification";
import useGameRoute from "./useGameRoute";

// Icon-only chrome — the level + xp are encoded in title/aria-label only.
// Visual is a 4-point burst that brightens once the user has any XP.
// Click opens the shared StatsModal via a window event so neither
// component needs to know about the modal.
const Wrap = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  line-height: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  &:hover svg path { stroke: var(--nd-text-display); }
  &:focus { outline: none; }
`;

const BurstSvg = ({ active }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
    <path
      d="M7 1 L8 6 L13 7 L8 8 L7 13 L6 8 L1 7 L6 6 Z"
      fill="none"
      stroke={active ? "var(--nd-text-display)" : "var(--nd-text-secondary)"}
      strokeWidth="1"
    />
  </svg>
);

const XpBadge = () => {
  const { user } = useAuth();
  const onGameRoute = useGameRoute();
  const { xp, level } = useXp(user && user.uid);
  if (!user || !onGameRoute) return null;
  const active = xp > 0;
  const label = `Level ${level}, ${xp} XP — open stats`;
  const onClick = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("gami:open-stats"));
    }
  };
  return (
    <Wrap type="button" title={label} aria-label={label} onClick={onClick}>
      <BurstSvg active={active} />
    </Wrap>
  );
};

export default XpBadge;
